/**
 * @file 判断环境
 */
var hostArr = ['cloud.baidu.com', 'bce.baidu.com', 'aipe-eng.baidu-int.com', 'appbuilder.cloud.baidu.com', 'qianfan.cloud.baidu.com', 'aisuda.cloud.baidu.com'];
function getEnv() {
  if (typeof window !== 'undefined') {
    var host = location.host;
    return hostArr.indexOf(host) > -1 ? 'ONLINE' : 'SANDBOX';
  }
}

export { getEnv };
